/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Load_FailedInputs */

const en_notes_v2_load_failed = /** @type {(inputs: Notes_V2_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes could not be loaded`)
};

const es_notes_v2_load_failed = /** @type {(inputs: Notes_V2_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las notas`)
};

/**
* | output |
* | --- |
* | "Notes could not be loaded" |
*
* @param {Notes_V2_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_load_failed = /** @type {((inputs?: Notes_V2_Load_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Load_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_load_failed(inputs)
	return en_notes_v2_load_failed(inputs)
});